import React from 'react';
import { Space } from 'antd';
import classNames from 'classnames';
import PrettyDate from '@/components/PrettyDate';
import DateIcon from '@/components/DateIcon';
import styles from '@/components/ProjectDetails/Cards/Items/index.less';
import { Message } from '@/components/Communication/types';
import { getMessageRenderer } from '@/components/Communication/factory';

export default function MessageItem({
  message,
  onClick,
}: {
  message: Message;
  onClick?: (message: Message) => void;
}) {
  const Renderer = getMessageRenderer(message.medium).Summary;

  return (
    <div
      onClick={() => onClick?.(message)}
      className={classNames(
        styles.projectDetailItemContainer,
        styles.messageItemContainer,
        { [styles.projectDetailItemContainerClickable]: !!onClick }
      )}
    >
      <div className={styles.projectDetailItemContent}>
        <div className={styles.projectDetailItemHeader}>
          <Renderer message={message} />
        </div>
        <div className={styles.projectDetailItemBody}>
          <Space size={4}>
            <DateIcon date={message.timestamp} />
            <PrettyDate date={message.timestamp} />
          </Space>
        </div>
      </div>
    </div>
  );
}
